module.exports = __webpack_public_path__ + "static/img/section_02_pedalboard_paradise_kv.3bd03ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/overview/section_02_pedalboard_paradise_kv.png
// module id = 7WvF
// module chunks = 12